import { render, staticRenderFns } from "./BaseSection.vue?vue&type=template&id=56773b1e&scoped=true"
import script from "./BaseSection.vue?vue&type=script&lang=js"
export * from "./BaseSection.vue?vue&type=script&lang=js"
import style0 from "./BaseSection.vue?vue&type=style&index=0&id=56773b1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56773b1e",
  null
  
)

export default component.exports